const PRIZE_COPY = {
  SENT_VIA_EMAIL: 'Your prize information will be sent to you via email.',
  USE_CODE_NOW: 'Use your code now to redeem your prize!',
  FOUND_IN_OFFERS: 'Your prize can be found in the Offers section and is ready for your next visit.',
  GIFT_CARD_WON: 'You’ve won a $50 e-gift card. Please see Gift Card details for you to redeem online at check-out.',
  GUEST_GRAND_PRIZE:
    'Congratulations you’ve won a VIP dinner. Our customer care team will contact you shortly to arrange this special prize for you.',
};

const PRIZE_DISCLAIMER = {
  ALLOW_48_HOURS_EMAIL: 'Please allow up to 48 hours for the email to arrive.',
  WRITE_DOWN_DETAILS: 'Make sure you record this code before spinning again, as you chose not to receive prize emails.',
};

export { PRIZE_COPY, PRIZE_DISCLAIMER };
